import { sortByDateDesc } from '../../../../utils/dates';
import { UserRole } from '../../../users/roles';
import { OrderStatus } from '../../interfaces/order-status.interface';
import { GetOrderGatewayPaymentDTO, StatusType } from '../../order.types';

export const getStatusToEditByRole = (role?: UserRole): Array<OrderStatus> => {
  if (role === 'ADMIN_MARCA') {
    return [StatusType.DRAFT, StatusType.IN_REVISION, StatusType.ON_APPROVAL];
  }

  if (role === 'VENDEDOR') {
    return [StatusType.DRAFT, StatusType.IN_REVISION];
  }

  return [StatusType.DRAFT];
};

export const getLastOrderGatewayPayment = (
  orderGatewayPayments: Pick<
    GetOrderGatewayPaymentDTO,
    'status' | 'createdAt' | 'updatedAt'
  >[] = [],
) => {
  return sortByDateDesc(orderGatewayPayments, 'createdAt')[0] || null;
};
